var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"py-5",attrs:{"id":"about"}},[_c('br'),_c('AboutMe'),_c('Skills')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }